import { Component, computed, input } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';

@Component({
  selector: 'app-market-samples-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './market-samples-tab.component.html',
  providers: [
    { provide: TabComponent, useExisting: MarketSamplesTabComponent },
  ],
})
export class MarketSamplesTabComponent extends TabComponent {
  override name = this.dictionaryService.get('MarketSamples');

  userId = input<string>();
  endpoint = computed(() => {
    const base = '/visits/tables/customer-type-samples';
    const id = this.userId();
    return id ? `${base}/${id}` : base;
  });

  public async main(): Promise<void> {}
}
